import { AxiosError } from 'axios';
import get from 'lodash/get';

/**
 * @returns function get message from errors
 */
export const getErrorMsg = (error: AxiosError) => {
  // console.log(error?.response);
  const message = get(error, 'response.data.errors[0].msg');
  if (message) return message;
  const detail = get(error, 'response.data.message');
  if (detail) {
    if (typeof detail === 'string') return detail;
  }
  const fallback = get(detail, '[0].msg', '');
  if (fallback) return fallback;
  if (error?.message) return error.message;
  return 'Something went wrong';
};
